import { useCallback } from 'react';
import { FR_BOLO_ROOT_PATH } from '../../router/constants';
import { useLocation, useNavigate } from 'react-router-dom';

export function useOpenFrBoloDetails(): (boloId?: number) => void {
    const navigate = useNavigate();
    const location = useLocation();

    return useCallback(
        (boloId?: number) => {
            navigate(`${FR_BOLO_ROOT_PATH}/${boloId}`, {
                state: { ...location.state },
                // Prevents new history records from being created when navigating between Event Details tabs.
                // Ensures that the Back button will take the user to the previous page, not the previous tab.
                replace: location.pathname.includes(FR_BOLO_ROOT_PATH),
            });
        },
        [location, navigate]
    );
}
